import LoadingButton from '@/common/components/base/button/loadingButton';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import usePersonalInquiryStore from '@/common/store/personalInquiry/usePersonalInquiry';
import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import PersonalInquiry from '@/modules/adjusterReportModules/IncidentParticipants/components/common/personalInquiry/PersonalInquiry';
import InitialLegalOwnerForm from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/owner/InitialLegalOwnerForm/InitialLegalOwnerForm';
import InitialRealOwnerForm from '@/modules/adjusterReportModules/IncidentParticipants/components/culprit/owner/InitialRealOwnerForm/InitialRealOwnerForm';
import { INITIAL_VISIT_LINKS } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import {
  IOwnerInformationForm,
  IOwnerPersonalInformationForm,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQuery.type';
import { usePatchOwnerInitialVisitInfoQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchOwnerInitialVisitInfo/patchOwnerInitialVisitInfoQueryOptions';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';

const InitialBodyRealOwnerForm = () => {
  const methods = useFormContext<IOwnerInformationForm>();
  const ownerType = useWatch({
    control: methods.control,
    name: 'personal_information.owner_type',
  });
  const { mutate, isPending: loading } =
    usePatchOwnerInitialVisitInfoQueryOptions();
  const navigate = useNavigate();
  const { id } = useParams();
  const onSubmit = (formData: IOwnerInformationForm) => {
    let formObject: IOwnerPersonalInformationForm;

    if (formData.personal_information?.owner_type === 'real') {
      formObject = {
        ...formData.personal_information,
        birthdate: !!formData.personal_information.birthdate
          ? convertPersianToGregorian(
              formData.personal_information.birthdate.toString(),
            )
          : null,
        name: null,
        registration_number: null,
        identity_issue_location:
          formData?.personal_information?.identity_issue_location || null,
        identity_number:
          formData?.personal_information?.identity_number !== ''
            ? formData?.personal_information?.identity_number
            : null,
        economic_code: null,
        father_name:
          formData?.personal_information?.father_name !== ''
            ? formData?.personal_information?.father_name
            : null,

        national_id: null,
        owner_type: formData.personal_information.owner_type,
      };
    } else {
      formObject = {
        ...formData.personal_information,
        gender: null,
        first_name: null,
        last_name: null,
        birthdate: null,
        father_name: null,
        national_code: null,
        identity_number: null,
        identity_issue_location: null,
        owner_type: formData.personal_information?.owner_type || null,
      };
    }
    mutate(
      { data: formObject, id: id! },
      {
        onSuccess: () => {
          clearInquiryData();
          navigate(INITIAL_VISIT_LINKS.OWNER_CONTACT_INFO(+id!), {
            replace: true,
          });
        },
      },
    );
  };
  const { data, clearInquiryData } = usePersonalInquiryStore();

  useEffect(() => {
    if (data?.national_code) {
      methods.reset({
        personal_information: {
          ...methods?.getValues(),
          birthdate: data?.birth_date_timestamp
            ? convertPersianToGregorian(data?.birth_date_timestamp.toString())
            : null,
          gender: data?.gender === 'MALE' ? 'male' : 'female',
          first_name: data?.first_name,
          last_name: data?.last_name,
          identity_number: String(data?.identification_number),
          identity_issue_location: data?.birth_place,
          owner_type: 'real',
          father_name: data?.father_name === '' ? null : data?.father_name,
        },
      });
    }
  }, [data]);

  return (
    <Flex direction="column" gap={8}>
      <Box py={24}>
        <PersonalInquiry outSideForm={useFormContext} />
      </Box>
      <RadioGroup
        title="نوع مالکیت"
        name="personal_information.owner_type"
        options={[
          { label: 'حقیقی', value: 'real' },
          { label: 'حقوقی', value: 'legal' },
        ]}
        renderRadioButton={(Component) => <Box>{Component}</Box>}
        className={css({ paddingBottom: '24px', gap: '2rem' })}
      />
      {ownerType === 'real' ? (
        <InitialRealOwnerForm />
      ) : (
        <InitialLegalOwnerForm />
      )}
      <Box w="100%">
        <LoadingButton
          onClick={methods.handleSubmit(onSubmit)}
          loading={loading}
          fullWidth
          disabled={!methods?.formState?.isValid}
        >
          ثبت و ادامه
        </LoadingButton>
      </Box>
    </Flex>
  );
};
export default InitialBodyRealOwnerForm;
